import React from 'react';
import { FormattedMessage } from 'react-intl';
import MainPage from 'components/MainPage';

const HomePage: React.FunctionComponent<{}> = () => (
  <MainPage canBadge>
    <FormattedMessage id="home.welcome" />
  </MainPage>
);

export default HomePage;
